<template>
  <div
    class="
      cursor-pointer
      relative
      rounded-full
      w-12
      h-12
      bg-vice-light-grey
      flex
      justify-center
      items-center
      hover:bg-gray-100
    "
    :class="{ 'sm:bg-vice-teal-600 hover:bg-vice-teal-700': isActive }"
    v-tippy="{
      content: btnDescription,
      theme: 'light-border',
      interactive: true,
    }"
  >
    <div
      class="
        absolute
        bg-vice-light-red
        rounded-full
        flex
        justify-center
        items-center
        z-20
        w-5
        h-5
        -top-1
        -right-1
      "
      v-if="isActive"
    >
      <div class="rounded-full bg-white w-2 h-2"></div>
    </div>

    <ViceLoader class="left-2" v-if="loading" />

    <template v-else>
      <ViceStethoscope
        class="w-12 h-12"
        :pathFill="!isActive ? '#0F766E' : '#fff'"
        v-if="icon == 'Medical'"
      />
      <ViceGlasses
        class="w-12 h-12"
        :pathFill="!isActive ? '#0F766E' : '#fff'"
        v-if="icon == 'Glasses'"
      />
      <ViceScreenshare
        class="w-9 h-9"
        :pathFill="!isActive ? '#0F766E' : '#fff'"
        v-if="icon == 'Screen'"
      />
      <ViceSmartphone class="w-10 h-10" pathFill="#0F766E" v-if="icon === 'Phone'" />
    </template>
  </div>
</template>

<script>
import { directive } from 'vue-tippy';
import ViceStethoscope from '../Icons/ViceStethoscope.vue';
import ViceSmartphone from '@/Components/Icons/ViceSmartphone.vue';
import ViceGlasses from '../Icons/ViceGlasses.vue';
import ViceScreenshare from '../Icons/ViceScreenshare.vue';
import ViceLoader from '../Loaders/ViceLoader.vue';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light-border.css';

export default {
  name: 'DeviceBadge',
  directives: {
    tippy: directive,
  },
  components: {
    ViceSmartphone,
    ViceStethoscope,
    ViceGlasses,
    ViceScreenshare,
    ViceLoader,
  },
  props: {
    icon: { type: String },
    isActive: {
      type: Boolean,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    btnDescription: { type: String, default: '' },
  },
};
</script>
